import React, { useState, useEffect } from "react";
import {
    FaBell,
    FaUserCircle,
    FaAngleDoubleRight,
    FaExpand,
    FaCompress,
    FaAngleDoubleLeft,
    FaBars,
    FaSignOutAlt,
} from "react-icons/fa";
import { apiRoutes } from "../../routes/api/apiRoutes";
import useApiCallHooks from "../../hooks/useApiCallHooks";
import { useNavigate } from "react-router-dom";
import { uiRoutes } from "../../routes/ui/uiRoutes";
import { getUserRoles } from "../../config/user";
const AdminNavBar = ({ collapsed, toggleSidebar }) => {
    const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isLogout, setIsLogout] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 576);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const toggleFullScreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
            setIsFullScreen(true);
        } else if (document.exitFullscreen) {
            document.exitFullscreen();
            setIsFullScreen(false);
        }
    };
    const logOut = () => {
        callAPI("post", apiRoutes.logout, "");
        localStorage.removeItem("udata");
        window.location.href = "/";
    };
    const role = getUserRoles();
    return (
        <nav
            className={`navbar navbar-light bg-white shadow-sm d-flex align-items-center ${
                isMobile ? "mobile-navbar" : "px-3 py-2 justify-content-between"
            }`}
        >
            {isMobile ? (
                <div className="container-fluid d-flex justify-content-between align-items-center">
                    {/* Sidebar toggle */}
                    <button
                        className="mobile-toggle-btn"
                        onClick={toggleSidebar}
                        aria-label="Toggle sidebar"
                    >
                        <FaBars size={20} />
                    </button>

                    {/* Logo */}
                    <div className="mobile-logo">
                        <img
                            src="/images/sys-new-logo2.png"
                            alt="Logo"
                            height={30}
                        />
                    </div>

                    {/* Bell + Logout */}
                    <div className="d-flex align-items-center gap-3">
                        <div className="position-relative">
                            <FaBell size={20} />
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                2
                            </span>
                        </div>
                        <FaSignOutAlt
                            size={20}
                            title="Logout"
                            className="cursor-pointer"
                            onClick={() => logOut()}
                        />
                    </div>
                </div>
            ) : (
                <>
                    <div className="d-flex align-items-center gap-3">
                        <button
                            className="sidebar-toggle-btn"
                            onClick={toggleSidebar}
                            aria-label="Toggle sidebar"
                        >
                            {collapsed ? (
                                <FaAngleDoubleRight size={20} />
                            ) : (
                                <FaAngleDoubleLeft size={20} />
                            )}
                        </button>
                        <span className="navbar-brand mb-0 h4">
                            {role && role[0]?.toUpperCase()}{" "}
                        </span>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        <button
                            className="fullscreen-btn"
                            onClick={toggleFullScreen}
                            aria-label="Toggle Fullscreen"
                        >
                            {isFullScreen ? (
                                <FaCompress size={18} />
                            ) : (
                                <FaExpand size={18} />
                            )}
                        </button>
                        <div className="position-relative me-2">
                            <FaBell size={20} />
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                2
                            </span>
                        </div>
                        <FaSignOutAlt
                            size={24}
                            title="Logout"
                            onClick={() => logOut()}
                        />
                    </div>
                </>
            )}
        </nav>
    );
};
export default AdminNavBar;
